export default {

    indexGridModalities:    { method: 'get',    url: 'grid_modalities' },
    storeGridModality:      { method: 'post',   url: 'grid_modalities' },
    updateGridModality:     { method: 'put',    url: 'grid_modalities/{id}'},
    destroyGridModality:    { method: 'delete', url: 'grid_modalities/{id}'},

}